'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var alloyImagePicker_module = require('./alloy-image-picker.module.scss.js');
var utilityFunctions = require('../../utilityFunctions.js');

var ImagePickerThumbnail = function (_a) {
    var _b = _a.images, images = _b === void 0 ? [] : _b, _c = _a.onClick, onClick = _c === void 0 ? null : _c, selectedImage = _a.selectedImage, _d = _a.fallbackImage, fallbackImage = _d === void 0 ? '' : _d, _e = _a.defaultTitle, defaultTitle = _e === void 0 ? '' : _e, _f = _a.initialContent, initialContent = _f === void 0 ? '' : _f, _g = _a.thumbnailPreset, thumbnailPreset = _g === void 0 ? '' : _g, _h = _a.fallbackOverlay, fallbackOverlay = _h === void 0 ? '' : _h, _j = _a.borderStyle, borderStyle = _j === void 0 ? '' : _j, count = _a.count;
    var defaultThumbnailOptions = {
        borderStyle: borderStyle === 'primary'
            ? 'alloy-carousel__border-primary'
            : 'alloy-carousel__border-secondary',
        initialContent: initialContent
    };
    var getThumbnailImages = function (options) {
        var index = options.index, url = options.url, borderStyle = options.borderStyle, title = options.title, imgSrc = options.imgSrc, initialContent = options.initialContent, type = options.type;
        return (jsxRuntime.jsxs("div", tslib.__assign({ "data-testid": "thumbnail-container", className: "".concat(alloyImagePicker_module.default['alloy-carousel__thumbnail'], " me-1 ms-1 position-relative mb-1") }, { children: [jsxRuntime.jsx("button", tslib.__assign({ "data-testid": "thumbnail-button", type: "button", className: "p-0 mw-100 mh-100 h-100 ".concat(alloyImagePicker_module.default['alloy-carousel__button'], " ").concat(alloyImagePicker_module.default[borderStyle]), onClick: function () {
                        onClick && onClick(index);
                    } }, { children: type === 'composite'
                        ? initialContent
                        : imgSrc && (jsxRuntime.jsx("img", { "data-testid": "thumbnail-image", src: imgSrc, alt: title || defaultTitle, width: "100%", height: "100%", loading: "lazy" })) })), fallbackImage && fallbackOverlay] }), type === 'composite'
            ? 'composite-image'
            : imgSrc
                ? "".concat(imgSrc, "-").concat(index)
                : "".concat(fallbackImage, "-").concat(url)));
    };
    //todo find better type to assign than any for getThumbnail
    var getThumbnails = function (images) {
        return images.slice(0, count).map(function (_a, index) {
            var type = _a.type, url = _a.url, title = _a.title;
            var borderStyle = index === selectedImage
                ? 'alloy-carousel__border-primary'
                : 'alloy-carousel__border-secondary';
            var imgSrc = utilityFunctions.isVideo(type)
                ? utilityFunctions.getYouTubeStill(url)
                : utilityFunctions.getImagePresetUrl(url, thumbnailPreset);
            return getThumbnailImages(tslib.__assign(tslib.__assign({}, defaultThumbnailOptions), { imgSrc: imgSrc, index: index, url: url, borderStyle: borderStyle, title: title, initialContent: type === 'composite' ? initialContent : '', type: type }));
        });
    };
    return (jsxRuntime.jsx(jsxRuntime.Fragment, { children: images && images.length > 0
            ? getThumbnails(images)
            : fallbackImage &&
                getThumbnailImages(tslib.__assign(tslib.__assign({}, defaultThumbnailOptions), { imgSrc: utilityFunctions.getImagePresetUrl(fallbackImage, thumbnailPreset), title: defaultTitle, url: '', index: -1 })) }));
};
var ImagePickerThumbnail$1 = ImagePickerThumbnail;

exports.default = ImagePickerThumbnail$1;
//# sourceMappingURL=ImagePickerThumbnail.js.map
